import { FC } from 'react'
import { Button, Typography, Stack } from '@mui/material'
import { ArrowOutwardRoundedIcon } from 'apps/doctor/src/assets/icons'
import clsx from 'clsx'
import { CardButtonProps } from './_props'
import makeStyle from './_style'

const CardButton: FC<CardButtonProps> = ({ icon, label, onClick }) => {
    const style = makeStyle()

    return (
        <Button onClick={onClick} className={clsx(style.cardButton)}>
            {icon}
            <Stack direction="row">
                <Typography>{label}</Typography>
                <ArrowOutwardRoundedIcon className={clsx(style.cardButtonIcon)} />
            </Stack>
        </Button>
    )
}

export default CardButton
